import { atom, useRecoilState } from 'recoil';

export const selectedDateAtom = atom<Date | null>({
  key: 'selectedDateAtom',
  default: null,
});

export const useSelectedDate = () => {
  const [selectedDate, setSelectedDate] = useRecoilState(selectedDateAtom);
  return { selectedDate, setSelectedDate };
};